import Analytics from "@/components/analytics";
import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";

const AnalyticsPage = () => {
  return (
    <PageLayout title="Analytics">
      <Analytics />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "AnalyticsPage" })(AnalyticsPage);
